import React from "react";

export default function StackedEmail() {
  return (
    <div className="mb-3">
      <svg
        width="68"
        height="68"
        viewBox="0 0 68 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="68" height="68" rx="34" fill="#00A5CE" fillOpacity="0.2" />
        <mask
          id="mask0_2074_20"
          maskUnits="userSpaceOnUse"
          x="12"
          y="12"
          width="44"
          height="44"
        >
          <rect x="12" y="12" width="44" height="44" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_2074_20)">
          <path
            d="M24.4809 42.9549C23.5547 42.9549 22.7708 42.6341 22.1292 41.9924C21.4875 41.3507 21.1667 40.567 21.1667 39.6412V21.5191C21.1667 20.5933 21.4875 19.8095 22.1292 19.1679C22.7708 18.5262 23.5547 18.2054 24.4809 18.2054H49.9358C50.8619 18.2054 51.6458 18.5262 52.2875 19.1679C52.9292 19.8095 53.25 20.5933 53.25 21.5191V39.6412C53.25 40.567 52.9292 41.3507 52.2875 41.9924C51.6458 42.6341 50.8619 42.9549 49.9358 42.9549H24.4809ZM36.2422 33.1466L23.9167 24.2549V39.6412C23.9167 39.8056 23.9695 39.9406 24.0752 40.0463C24.181 40.1524 24.3162 40.2054 24.4809 40.2054H49.9358C50.1005 40.2054 50.2357 40.1524 50.3414 40.0463C50.4471 39.9406 50.5 39.8056 50.5 39.6412V24.2549L38.1745 33.1466C37.8735 33.3675 37.5515 33.478 37.2083 33.478C36.8652 33.478 36.5431 33.3675 36.2422 33.1466ZM37.2083 30.4814L50.3235 21.0608C50.2884 21.0257 50.2502 20.9992 50.209 20.9815C50.168 20.9638 50.1123 20.9549 50.0417 20.9549H24.375C24.3163 20.9549 24.2575 20.9697 24.1985 20.9994C24.1399 21.0287 24.093 21.0609 24.0578 21.0961L37.2083 30.4814ZM18.0642 49.3716C17.1381 49.3716 16.3542 49.0508 15.7125 48.4091C15.0708 47.7674 14.75 46.9837 14.75 46.0578V27.2662C14.75 26.876 14.8817 26.5493 15.1451 26.2863C15.4082 26.0229 15.7348 25.8912 16.125 25.8912C16.5152 25.8912 16.8418 26.0229 17.1049 26.2863C17.3683 26.5493 17.5 26.876 17.5 27.2662V46.0578C17.5 46.2222 17.5529 46.3573 17.6586 46.463C17.7643 46.5687 17.8995 46.6216 18.0642 46.6216H45.3525C45.7427 46.6216 46.0694 46.7533 46.3328 47.0167C46.5959 47.2797 46.7275 47.6064 46.7275 47.9966C46.7275 48.3868 46.5959 48.7136 46.3328 48.977C46.0694 49.24 45.7427 49.3716 45.3525 49.3716H18.0642ZM50.5 24.1706C50.5 23.5735 50.4794 23.0464 50.4381 22.5893C50.3972 22.1322 50.359 21.6227 50.3235 21.0608C50.2884 21.0257 50.2502 20.9992 50.209 20.9815C50.168 20.9638 50.1123 20.9549 50.0417 20.9549H24.375C24.3163 20.9549 24.2575 20.9697 24.1985 20.9994C24.1399 21.0287 24.093 21.0609 24.0578 21.0961C24.0224 21.658 23.99 22.1645 23.9607 22.6155C23.9313 23.0668 23.9167 23.5851 23.9167 24.1706V20.9549H50.5V24.1706Z"
            fill="#004B66"
          />
        </g>
      </svg>
    </div>
  );
}
